module.exports = __webpack_public_path__ + "static/media/Contrast.3143d7ec.svg";